"use client";
import styles from "@/app/layout.module.scss";

interface FeatureLockedModalProps {
    featureName: string;
    onClose: () => void;
}

export default function FeatureLockedModal({ featureName, onClose }: FeatureLockedModalProps) {
    return (
        <div className={styles.logoutModal} onClick={onClose}>
            <div className={styles.logoutCard} onClick={(e) => e.stopPropagation()}>
                <div className={styles.logoutIcon}>🔒</div>
                <h3>Feature Locked</h3>
                <p>
                    <strong>{featureName.replace(/_/g, " ")}</strong> is not included in your current plan.
                </p>
                <div className={styles.logoutActions}>
                    <button className={styles.cancelBtn} onClick={onClose}>
                        Ok
                    </button>
                </div>
            </div>
        </div>
    );
}
